import React from "react";
import "../css/nanny.css";
import Header from "../Headers/Header";
import HeaderLink from "../Headers/HeaderLink";
import LeftContent from "./LeftContent";
import Lottie from "react-lottie";
import success5 from "../img/success.json";

export default function Step4(props) {
  if (props.currentStep !== 5) {
    return null;
  }

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: success5,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <React.Fragment>
      <div className="d-lg-block d-none">
        <Header />
      </div>
      <div className="d-lg-none d-block">
        <HeaderLink gotoMomKidCare={props.gotoMomKidCare} />
      </div>
      <div className="container p-lg-4  mt-lg-5">
        <div className="row mx-auto mb-2">
          {/* Partition  one*/}
          <div className="col-lg-5 p-lg-5 mt-lg-0 mt-5 pt-5 pt-lg-0">
            <LeftContent gotoMomKidCare={props.gotoMomKidCare} />
          </div>

          <div className="col-lg-7 mt-2 ">
            <div className="row mx-auto mx-lg-0 mb-lg-0 mb-5">
              <div
                className="col-lg-12 mt-5 mainContent"
                style={{ borderRadius: "10px", height: "400px" }}
              >
                <div className="col mt-5">
                  <Lottie options={defaultOptions} height={150} width={150} />
                </div>
                <div className="col mt-2">
                  <p
                    style={{
                      color: "#005495",
                      fontFamily: "Montserrat, Medium",
                    }}
                  >
                    Thank you for your registration our team will verify the
                    details and get back to you or call us at{" "}
                    <a href="tel:08047193999">08047193999</a>
                  </p>
                  <span
                    style={{
                      fontSize: "13px",
                      color: "#6B6B6B",
                      fontFamily: "Tahoma, Regular",
                    }}
                  >
                    (आपके पंजीकरण के लिए धन्यवाद, हमारी टीम विवरणों की पुष्टि
                    करेगी और आपसे संपर्क करेगी या हमें{" "}
                    <a href="tel:08047193999">08047193999</a> पर कॉल करें){" "}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
